export const getRegisterCompanyName = (data) => {
  const reg_name = getValideRegName(data);
  const substrPosition = reg_name.toLowerCase().indexOf('t/a');
  if (substrPosition > 0) {
    return reg_name.substr(0, substrPosition - 1);
  }
  return reg_name;
};

const getValideRegName = (data) => {
  return data &&
    data.business_details &&
    data.business_details.registered_company &&
    data.business_details.registered_company.name
    ? data.business_details.registered_company.name
    : '';
};

export const getRegisterCompanyNumber = (data) =>
  data &&
  data.business_details &&
  data.business_details.registered_company &&
  data.business_details.registered_company.number
    ? data.business_details.registered_company.number
    : '';
